const actionNames = {
  AUTO_AUTH_COMPLETE: 'AUTO_AUTH_COMPLETE',
  AUTH_CHECK_REQUESTED: 'AUTH_CHECK_REQUESTED',

  SHOW_HELP: 'SHOW_HELP',

  SET_ALIAS_MODE_REQUESTED: 'SET_ALIAS_MODE_REQUESTED',
  SET_ALIAS_MODE_SUCCEEDED: 'SET_ALIAS_MODE_SUCCEEDED',
  SET_ALIAS_MODE_FAILED: 'SET_ALIAS_MODE_FAILED',

  SET_DEMO_MODE_REQUESTED: 'SET_DEMO_MODE_REQUESTED',
  SET_DEMO_MODE_SUCCEEDED: 'SET_DEMO_MODE_SUCCEEDED',
  SET_DEMO_MODE_FAILED: 'SET_DEMO_MODE_FAILED',

  SET_DEV_MODE_REQUESTED: 'SET_DEV_MODE_REQUESTED',
  SET_DEV_MODE_SUCCEEDED: 'SET_DEV_MODE_SUCCEEDED',
  SET_DEV_MODE_FAILED: 'SET_DEV_MODE_FAILED',

  SIGN_IN_REQUESTED: 'SIGN_IN_REQUESTED',
  SIGN_IN_SUCCEEDED: 'SIGN_IN_SUCCEEDED',
  SIGN_IN_FAILED: 'SIGN_IN_FAILED',

  SIGN_OUT_REQUESTED: 'SIGN_OUT_REQUESTED',
  SIGN_OUT_SUCCEEDED: 'SIGN_OUT_SUCCEEDED',
  SIGN_OUT_FAILED: 'SIGN_OUT_FAILED',
}

export default actionNames
